import { useQuery } from "react-query";
import axios from "infra/http";

function useGetCidades(estadoId?: string | null) {
  return useQuery(
    `/v1/estado/${estadoId}/cidades`,
    async () => {
      const { data } = await axios.get(`/v1/estado/${estadoId}/cidades`);

      return data;
    },
    {
      enabled: !!estadoId,
    }
  );
}

export default useGetCidades;
